import { render, staticRenderFns } from "./ChainMemberSelection.vue?vue&type=template&id=1bb47d57&"
import script from "./ChainMemberSelection.vue?vue&type=script&lang=js&"
export * from "./ChainMemberSelection.vue?vue&type=script&lang=js&"
import style0 from "./ChainMemberSelection.vue?vue&type=style&index=0&id=1bb47d57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports